module.exports = __webpack_public_path__ + "img/spiree.2881a0a0.jpg";